import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/VOIndexRegister'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'(P) VO Index/Register'}
        >
            <Component 
            />


        </Layout>
    )
}

export default BlockInspectionStatusMasterlist